export default __webpack_public_path__ + "_/images/referrals/icon-phone-3c88c029fc02cd776f34305b38dd45bb2832deb121448b5ba10a1e13846e9b25.png";